import _defineProperty from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["features"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { forwardRefWithAs as r, render as i } from '../utils/render.js';
var a = "div";

var p = function (e) {
  return e[e.None = 1] = "None", e[e.Focusable = 2] = "Focusable", e[e.Hidden = 4] = "Hidden", e;
}(p || {});

function s(t, o) {
  var _t$features = t.features,
      n = _t$features === void 0 ? 1 : _t$features,
      e = _objectWithoutProperties(t, _excluded),
      d = {
    ref: o,
    "aria-hidden": (n & 2) === 2 ? !0 : void 0,
    style: _objectSpread({
      position: "fixed",
      top: 1,
      left: 1,
      width: 1,
      height: 0,
      padding: 0,
      margin: -1,
      overflow: "hidden",
      clip: "rect(0, 0, 0, 0)",
      whiteSpace: "nowrap",
      borderWidth: "0"
    }, (n & 4) === 4 && (n & 2) !== 2 && {
      display: "none"
    })
  };

  return i({
    ourProps: d,
    theirProps: e,
    slot: {},
    defaultTag: a,
    name: "Hidden"
  });
}

var c = r(s);
export { p as Features, c as Hidden };